import React, { useEffect, useState } from 'react';
import { Avatar, Box, Circle, Divider, Flex, Image, Pressable, Text, View, HStack, VStack, useTheme } from 'native-base';
import Replies from '../replies/Replies';
import InteractionBar from '../common/InteractionBar';
import { displayTime, checkPrevAndNextPropsAreEqual, flattenProductCategories, getLikedReplyIDs, getSourceHTML, addInlineStyleToMentionBlot, getFriendlyOrDiscourseUsername } from '../../utils/helpers';
import { DEVICE_WIDTH, AVATAR_SIZE } from '../../Constants';
import { useAuthState } from '../../../context/auth';
import { useEnvState } from '../../../context/env';
import { useCategoriesState } from '../../../context/categories';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import RenderHtml from 'react-native-render-html';
import { faHeart } from '@fortawesome/pro-solid-svg-icons';
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';
import { Platform } from 'react-native';
import IconShield from '../common/reusables/IconShield';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons';
import Post from '../common/reusables/Post';
import { useDomParser } from '../../hooks/useDomParser';
const Topic = _ref => {
  var _categories$filter$;
  let {
    topic,
    updateTopicPost,
    loadContents,
    updateTopicReplies,
    updateTopicOnReplyCreate,
    navigation,
    platformUser,
    showUserProfile,
    forumKey,
    setPassedReactRef,
    repliesStream,
    forSingleTopicScreen,
    forceReloadToggle,
    trackForum
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const [repliesDisplay, setRepliesDisplay] = useState(false);
  const {
    id,
    posts_count,
    created_at,
    like_count,
    category_id
  } = topic;
  const authState = useAuthState();
  const categoriesState = useCategoriesState();
  const {
    rootProductCategory
  } = categoriesState;
  const [likedReplyIDs, setLikedReplyIDs] = useState(getLikedReplyIDs([topic.first.post, ...topic.recent.map(p => p.post)]));
  const [renderedLikeCount, setRenderedLikeCount] = useState(like_count);
  const categories = flattenProductCategories(rootProductCategory);
  const categoryName = categories === null || categories === void 0 ? void 0 : (_categories$filter$ = categories.filter(category => (category === null || category === void 0 ? void 0 : category.id) === category_id)[0]) === null || _categories$filter$ === void 0 ? void 0 : _categories$filter$.name;
  const {
    getParser,
    normalizeImages,
    displayAtMentions
  } = useDomParser();
  const [sharedComment, setSharedComment] = useState(false);
  useEffect(() => {
    (async function () {
      if (forumKey && forumKey.path && forumKey.path.post && forumKey.path.id) {
        if (forumKey.path.post === 'topic') {
          if (topic.id == forumKey.path.id) setSharedComment(true);
        }
      }
    })();
  }, [forumKey]);
  const addLikedReplyID = replyID => {
    setLikedReplyIDs([...likedReplyIDs, replyID]);
    setRenderedLikeCount(renderedLikeCount + 1);
  };
  const removeLikedReplyID = replyID => {
    setLikedReplyIDs([...likedReplyIDs].filter(id => id !== replyID));
    setRenderedLikeCount(renderedLikeCount - 1);
  };
  const getAvatarOfPoster = posterUser => {
    if (!posterUser) {
      return '';
    }
    if (posterUser) {
      let avatarTemplate = envState.base_url + posterUser.avatar_template.replace(/\{size\}/, AVATAR_SIZE);
      // if this is auth user, override with auth avatar
      if (posterUser.id === authState.discourse_user_id) {
        avatarTemplate = authState.auth_user_avatar;
      }
      return avatarTemplate;
    }
  };
  const getPoster = () => {
    return topic.original_poster ? topic.original_poster : null;
  };
  const poster = getPoster();
  const avatarOfPoster = getAvatarOfPoster(poster);
  const posterUser = {
    ...(poster && {
      id: poster.id,
      name: getFriendlyOrDiscourseUsername(poster, 'friendly'),
      username: getFriendlyOrDiscourseUsername(poster, 'discourse'),
      moderator: poster.moderator || topic.first.post.moderator
    }),
    avatar_template: avatarOfPoster
  };
  const boxWidth = Platform.OS === 'web' ? null : DEVICE_WIDTH;
  let sourceHTML = getSourceHTML(topic.first.post, colors);

  // parse/normalize markup
  const parser = getParser();
  if (parser) {
    sourceHTML = normalizeImages(parser, sourceHTML, envState.layout_width, 'topic');
    sourceHTML = displayAtMentions(parser, sourceHTML);
    sourceHTML = addInlineStyleToMentionBlot(parser, sourceHTML, colors);
  }
  let wlcBadge = topic.first.post.user_badges.filter(ub => ub.name === 'wlc')[0];
  const [ref] = setPassedReactRef ? setPassedReactRef() : [null];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: `topic-${topic.id}`,
    ref: sharedComment ? ref : null
  }, /*#__PURE__*/React.createElement(Box, {
    w: boxWidth,
    bg: sharedComment ? colors.topic.bg.highlight : colors.topic.box.default,
    borderWidth: sharedComment ? 2 : null,
    borderColor: sharedComment ? colors.reply.unique.border : null
  }, /*#__PURE__*/React.createElement(Box, {
    px: 4
  }, /*#__PURE__*/React.createElement(View, {
    mb: 2
  }, topic.pinned && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faThumbtack,
    color: colors.topic.pinned
  })), /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center',
    w: '100%'
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => showUserProfile(posterUser)
  }, /*#__PURE__*/React.createElement(Avatar, {
    id: "avatar-id-here",
    source: {
      uri: avatarOfPoster
    },
    size: 'md',
    mr: 2,
    ml: -1
  }, "Replier Profile Image"), posterUser.moderator === true && /*#__PURE__*/React.createElement(IconShield, {
    bottom: 0,
    right: 4
  })), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => showUserProfile(posterUser)
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center',
    justifyContent: 'center',
    space: 1
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: 'bold'
  }, posterUser.name, "."), posterUser.moderator && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faShieldHalved,
    color: colors.reply.moderator.icon,
    size: "xl"
  }), !!wlcBadge && /*#__PURE__*/React.createElement(Image, {
    source: {
      uri: wlcBadge.image_url
    },
    alt: wlcBadge.description,
    size: "2xs"
  }))), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.topic.text.created,
    fontSize: '2xs'
  }, displayTime(created_at), " ago", categoryName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: '2xs'
  }, " in "), /*#__PURE__*/React.createElement(Text, {
    fontSize: '2xs',
    color: colors.topic.text.category.name
  }, "#", categoryName)))))), /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.reply.text.content,
    mt: 2
  }, /*#__PURE__*/React.createElement(RenderHtml, {
    defaultTextProps: {
      selectable: true
    },
    contentWidth: Platform.OS === 'web' ? null : DEVICE_WIDTH,
    tagsStyles: Post.tagsStyles,
    source: {
      html: sourceHTML
    },
    renderersProps: Post.renderersProps(navigation, topic.id, showUserProfile, envState.base_url)
  })))), /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: 4,
    px: 4
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 2
  }, /*#__PURE__*/React.createElement(Circle, {
    size: '20px',
    bg: colors.topic.heart.circle
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faHeart,
    color: colors.topic.heart.icon
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, null, renderedLikeCount))), /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Text, null, posts_count > 1 ? `${posts_count - 1} ${posts_count > 2 ? 'replies' : 'reply'}` : 'No replies', ' '))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(InteractionBar, {
    topic: topic,
    reply: topic.first.post,
    loadContents: loadContents,
    updateTopicReplies: updateTopicReplies,
    updateTopicOnReplyCreate: updateTopicOnReplyCreate,
    updateTopicPost: updateTopicPost,
    navigation: navigation,
    parent: 'Topic',
    platformUser: platformUser,
    likedReplyIDs: likedReplyIDs,
    addLikedReplyID: addLikedReplyID,
    removeLikedReplyID: removeLikedReplyID,
    sharedComment: sharedComment,
    trackForum: trackForum
  }), posts_count > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Replies, {
    topic: topic,
    loadContents: loadContents,
    updateTopicReplies: updateTopicReplies,
    likedReplyIDs: likedReplyIDs,
    setLikedReplyIDs: setLikedReplyIDs,
    addLikedReplyID: addLikedReplyID,
    removeLikedReplyID: removeLikedReplyID,
    navigation: navigation,
    platformUser: platformUser,
    showUserProfile: showUserProfile,
    forSingleTopicScreen: forSingleTopicScreen,
    forceReloadToggle: forceReloadToggle,
    forumKey: forumKey,
    setPassedReactRef: setPassedReactRef,
    trackForum: trackForum
  })) : null)), /*#__PURE__*/React.createElement(Box, null));
};
function topicPropsAreEqual(prevTopic, nextTopic) {
  const propsToCompare = ['last_posted_at', 'category_id', 'bumped_at', 'pinned', 'notification_level', 'posts_count', 'forceReloadToggle'];
  return checkPrevAndNextPropsAreEqual('topic', prevTopic, nextTopic, propsToCompare);
}
const MemoizedTopic = /*#__PURE__*/React.memo(Topic, topicPropsAreEqual);
export default MemoizedTopic;
//# sourceMappingURL=Topic.js.map